import request from '@/request'

const FeedbackAndEnroll = {
  state: {},
  mutations: {},
  actions: {
    async submitFeedback ({ state }, payload) {
      let response = { code: 'init', massage: null }
      await request({
        method: 'post',
        headers: {
          Authorization: 'Bearer ' + state.accessToken
        },
        url: process.env.VUE_APP_API_SUBMIT_FEEDBACK,
        data: payload
      })
        .then((res) => {
          console.log('submitFeedback response >>> ', res)
          response = res
        })
        .catch((error) => {
          console.error('error :', error)
        })
      return response
    },
    async submitFormEnroll ({ state }, payload) {
      let response = { code: 'init', massage: null }
      await request({
        method: 'post',
        headers: {
          Authorization: 'Bearer ' + state.accessToken
        },
        url: process.env.VUE_APP_API_ENROLL_FORM,
        data: payload
      })
        .then((res) => {
          console.log('submitFormEnroll response >>> ', res)
          response = res
        })
        .catch((error) => {
          console.error('error :', error)
        })
      return response
    }
  },
  getters: {}
}
export default FeedbackAndEnroll